import './index.scss';

class Countdown extends HTMLElement {

  /**
 *   @example
 *   <f-countdown
 *     data-format="'Il reste 'dd'j 'hh'h 'mm'm 'ss's'"
 *     datetime="2022-11-06T22:59:00.0000000Z"
 *   >
 *     ...
 *   </f-countdown>;
 *   //example data-format : "'Il reste 'dd'j 'hh'h 'mm'm 'ss's'";
 *   //example data-format : "'<span class=\"test\">Il reste </span>'dd'j 'hh'h 'mm'm 'ss's'";
 */

  constructor() {

    super();

    this.labelClass = '.f-countdown__label';
    this.endDate = new Date(this.getAttribute('datetime'));
    this.format = '';
    this.isFinished = false;
    this.initializeClock();
  }

  createCountdown(endDate) {

    const isFinished = this.isFinished;

    let label = this.querySelector(this.labelClass);
    label.innerHTML = this.format.replaceAll(/\\.|".+?"|'.+?'|%[dmhs]|[dmhs]+/g, function (match) {
        switch (match.charAt(0)) {
          // Escaped char
          case '\\':
            return match.charAt(1);
          // Literal string
          case '"':
          case "'":
            return match.substr(1, match.length - 2);
          // Single Custom Format Specifiers.
          case '%':
            match = match.substr(1);
            break;
          // fix length of custom format specifiers:
          case 'h':
            match = match.substring(0, 2);
            break;
          case 'd':
          case 'm':
            match = match.substring(0, 4);
            break;
        }

        const t = endDate - Date.now();

        switch (match) {
          case 'dd':
            // Si le timer est terminé, on affiche 0
            return (isFinished) ? '0' : ('' + Math.floor(t / (1000 * 60 * 60 * 24))).substr(-2);
          case 'hh':
            return (isFinished) ? '0' : ('' + Math.floor((t / (1000 * 60 * 60)) % 24)).substr(-2);
          case 'mm':
            return (isFinished) ? '0' : ('' + Math.floor((t / 1000 / 60) % 60)).substr(-2);
          case 'ss':
            return (isFinished) ? '0' : ('' + Math.floor((t / 1000) % 60)).substr(-2);
        }
        return '';
      });
  }

  initializeClock = () => {

    const endDate = this.endDate;
    const now = new Date();
    const diff = endDate - now;
    let timeout = 1000;

    this.format = this.dataset.format;

    if (diff > 60 * 60 * 1000) {
      // Plus d'une heure restante : rafraîchissement chaque minute
      timeout = 60 * 1000;
    } else if (diff > 0) {
      // Moins d'une heure restante : rafraîchissement chaque seconde
      const refreshFormat = this.dataset.refresh;

      if (refreshFormat) {
        this.format = refreshFormat;
      }
    } else {
      // Temps écoulé
      this.isFinished = true;
      this.createCountdown(endDate);
      return;
    }

    this.createCountdown(endDate);
    this._timeoutId = setTimeout(this.initializeClock, timeout);
  };

  disconnectedCallback = () => {
    if (this._timeoutId) {
      clearTimeout(this._timeoutId);
      this._timeoutId = null;
    }
  };

}

customElements.get('f-countdown') || customElements.define('f-countdown', Countdown);
